import * as React from 'react'
import { Query } from 'react-apollo'

import { BookmarkButton as BookmarkButtonData } from './__generated__/BookmarkButton'
import BookmarkAuthModal from './BookmarkAuthModal'
import Bookmarked from './Bookmarked'
import { Style } from './Icon'
import { BOOKMARK_BUTTON_QUERY } from './query'
import Unbookmarked from './Unbookmarked'

interface IProps {
  schoolId: number
  style: Style
}

export default function BookmarkButton(props: IProps) {
  const { schoolId, style } = props
  const [authModal, setAuthModal] = React.useState<boolean>(false)
  const handleRequestOpenAuthModal = () => setAuthModal(true)

  return (
    <Query<BookmarkButtonData> query={BOOKMARK_BUTTON_QUERY}>
      {({ data }) => {
        const innerProps = {
          onRequestOpenAuthModal: handleRequestOpenAuthModal,
          schoolId,
          style,
          user: data ? data.user : null,
        }

        const lead = ((data && data.leads) || []).find(l => l.schoolId === schoolId)
        const isBookmarked = lead ? lead.isBookmarked : false

        return (
          <div data-pendo="bookmarkButton">
            {isBookmarked ? <Bookmarked {...innerProps} /> : <Unbookmarked {...innerProps} />}
            {authModal && (
              <BookmarkAuthModal
                isBookmarked={isBookmarked}
                schoolId={schoolId}
                onRequestClose={() => setAuthModal(false)}
              />
            )}
          </div>
        )
      }}
    </Query>
  )
}
